export default __webpack_public_path__ + "static/media/G0500.34I-26273_-17346_0.1666264020000.1d3110ef.jpg";